module.exports = __webpack_public_path__ + "img/logo.a6cb39c5.svg";